<template>
  <div class="mit-manage-building-page mit-page">

      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Manage Building {{$route.params.buildingMitId}}</v-card-title>
            <v-card-subtitle class="caption">See buildings info and manage spaces that don't exist on map.</v-card-subtitle>
            <v-divider></v-divider>

            <v-card-text>
                Tree goes here

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import MitSpacesService from '../../services/MitSpacesService.js';
  export default {
      name: 'MitManageBuildingsPage',
      components: {
      },
      data: function() {
          return {
              buildings:[]
          }
      },
      created() {
            //get current settings
            MitSpacesService.getBuildingsMitIdUniqueList()
            .then((buildings) => {
                this.loadingBuildings = false;
                this.buildings = buildings;
                //select the first one by default
                if(this.buildings.length > 0){
                    this.selectedBuilding = 0;
                    this.selectBuilding();
                }
            })
            .catch((error)=>{
                this.loadingBuildings = false;
            });
      }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
